module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/base/footer/footer.component.html
// module id = 854
// module chunks = 0